import { useEffect, useState } from "react";

const UNINITIALIZED = Symbol("uninitialized");

export default function useStaticFormListener({ options = {}, formData } = {}) {
  const [valueHeard, setValueHeard] = useState(UNINITIALIZED);
  const [customParams, setCustomParams] = useState({});

  useEffect(() => {
    if ("reload" in options) {
      if (Array.isArray(options.reload)) {
        const newParams = options.reload.reduce(
          (acc, { form_field, var_to_send }) => {
            if (customParams[var_to_send] !== formData[form_field])
              return acc
                ? { ...acc, [var_to_send]: formData[form_field] }
                : { [var_to_send]: formData[form_field] };
            return acc;
          },
          null,
        );
        if (newParams) setCustomParams((prev) => ({ ...prev, ...newParams }));
      } else {
        const formValue = formData[options.reload.form_field];
        if (formValue !== valueHeard) {
          setValueHeard(formValue);
          setCustomParams({ [options.reload.var_to_send]: formValue });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  return [customParams, "reload" in options, valueHeard];
}
